import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import map from 'lodash/map';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Form from 'antd/lib/form/Form';
import Item from 'antd/lib/form/FormItem';
import Select from 'antd/lib/select';

import { supplierDescriptionFields } from 'components/Settings/fieldsConstants';
import { updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { mixpanelTrack } from 'utils/mixpanel/mixpanel';
import { EMixpanelDataKeys, EMixpanelEvents } from 'utils/mixpanel/mixpanelTypes';
import sendGTM from 'utils/sendGTM';
import { GTM_VIEW_TELL_US_MODAL } from 'utils/constants/gtmConstants';
import { EAccountSupplierFields } from 'types/settings/enums';

const { Option } = Select;

const { Website, ProductSources, SkuAmount, SellingCountries } = EAccountSupplierFields;
const keys = [Website, ProductSources, SkuAmount, SellingCountries];
const tellUsFields = filter(supplierDescriptionFields, ({ name }) => includes(keys, name));

const TellUs: FC<{ onModalClose: () => void }> = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const handleSubmit = async(values: any) => {
    setIsUpdating(true);
    await dispatch(updateSettingsByKeyAction(
      { ...values, skuAmount: +values.skuAmount },
      ESettingsKey.AccountSettings,
    ));
    setIsUpdating(false);
    onModalClose();
  };

  useEffect(() => {
    sendGTM(GTM_VIEW_TELL_US_MODAL);
    mixpanelTrack(
      EMixpanelEvents.ViewWindow,
      { [EMixpanelDataKeys.WindowType]: 'Suppliers Registration', [EMixpanelDataKeys.WindowName]: 'business_info' },
    );
  }, []);

  return (
    <div className="w-[420px]">
      <h2 className="my-4">Please Tell Us</h2>
      <p className="mb-4 font-regular">Help us learn more about you & your services by filling in the fields below.</p>
      <Form layout="vertical" validateTrigger="onSubmit" onFinish={handleSubmit}>
        {map(tellUsFields, ({ component: Component, componentProps, options, ...itemProps }, key) =>
          <Item key={key} validateFirst {...itemProps}>
            <Component size="large" placeholder={`Enter ${itemProps.label}`} {...componentProps}>
              {options && map(options, ({ id, description }) => <Option key={id} value={id}>{description}</Option>)}
            </Component>
          </Item>)}
        <Divider />
        <div className="flex items-center justify-end">
          <Button
            type="link"
            className="text-black-70 dark:text-black-30"
            size="large"
            onClick={onModalClose}
          >
            Skip
          </Button>
          <Button type="primary" size="large" loading={isUpdating} htmlType="submit">Save</Button>
        </div>
      </Form>
    </div>
  );
};

export default TellUs;
